export default __webpack_public_path__ + "static/Guaranteed-b7a5834b20f9095397318829dcdba0f2.png";